import { useLocation, useNavigate } from 'react-router-dom';
import { ReactSVG } from "react-svg";
import CommonAuthComponent from './CommonAuthComponent';

const PasswordChangedSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isNewUser = (() => {
    const params = new URLSearchParams(location.search);
    const raw = params.get('isNewUser') ?? '';
    const val = String(raw).toLowerCase();
    return ['true', '1', 'yes'].includes(val);
  })();

  const handleSignInNow = () => {
    navigate(isNewUser ? '/login?isNewUser=true' : '/login');
  };

  return (
    <CommonAuthComponent>
      <div className="flex flex-col items-center">

        {/* Success Icon */}
        <div className="flex items-center justify-center mb-[20px]">
          <img
            src="/icons/circle-tick-box.svg"
            className="!h-[80px] w-[80px]"
          />
        </div>

        {/* Heading */}
        <h1 className="text-[22px] text-center mb-[10px] font-medium leading-[30px]">
          {isNewUser ? 'Password Created!' : 'Password Changed'}
        </h1>

        {/* Success Message */}
        <p className="text-center text-[16px] mb-[32px] font-normal leading-[22px]">
          {isNewUser ? 'Your password has been created successfully.' : 'Your password has been changed successfully.'}
        </p>

        {/* Sign In Now Button */}
        <button
          onClick={handleSignInNow}
          className="w-full inline-flex disabled:opacity-50 rounded-[4px] border transition-all duration-300 text-body-lg items-center font-semibold justify-center px-6 py-3.5
            bg-REELTeal border border-transparent hover:bg-teal-200 text-white"
        >
          Sign in now
        </button>
      </div>
    </CommonAuthComponent>
  );
};

export default PasswordChangedSuccess;
